import { DotsDropdownRow, DotsDropdownWrapper, DotsInfo, DotsLogo } from "./DotsDropdown.styled";

export const DotsDropdown = ({ collection = null, creator = null, owner = null }) => {
  return (
    <DotsDropdownWrapper>
      {owner && (
        <DotsDropdownRow>
          <DotsLogo alt='owner logo' src='../assets/img/default/nft/smile_1.png' />
          <DotsInfo>
            <span>Owner:</span>
            <a>@{owner?.name}</a>
          </DotsInfo>
        </DotsDropdownRow>
      )}
      {creator && (
        <DotsDropdownRow>
          <DotsLogo alt='ccreator logo' src='../assets/img/default/nft/smile_1.png' />
          <DotsInfo>
            <span>Creator:</span>
            <a>@{creator?.name}</a>
          </DotsInfo>
        </DotsDropdownRow>
      )}
      {collection && (
        <DotsDropdownRow>
          <DotsLogo alt='collection logo' src='../assets/img/default/nft/smile_1.png' />
          <DotsInfo>
            <span>Collection:</span>
            <a>@{collection?.title} </a>
          </DotsInfo>
        </DotsDropdownRow>
      )}
    </DotsDropdownWrapper>
  );
};
